<template>
    <!-- 我的 -->
    <div  class="wode">
    <TopNavigation  class="topNavigation"></TopNavigation>
        <div class="typeArea">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item class="bread">个人资料</el-breadcrumb-item>
            </el-breadcrumb>

            <div class="conetenr">
                <el-menu
                :default-active="menuInx"
                class="el-menu-vertical-demo"
                @select="handleSelect"
                >
                    <el-menu-item index="1">
                        <span slot="title">个人资料</span>
                    </el-menu-item>
                    <el-menu-item index="2">
                        <span slot="title">用户认证</span>
                    </el-menu-item>
                    <el-menu-item index="3">
                        <span slot="title">账号设置</span>
                    </el-menu-item>
                    <el-menu-item index="4">
                        <span slot="title">密码设置</span>
                    </el-menu-item>
                    <el-menu-item index="5">
                        <span slot="title">我的钱包</span>
                    </el-menu-item>
                    <el-menu-item index="6">
                        <span slot="title">船司账号</span>
                    </el-menu-item>
                    <el-menu-item index="7">
                        <span slot="title">平台协议</span>
                    </el-menu-item>
                </el-menu>

                <!-- 内容 -->
                <div class="menu-con">
                    <div class="yi" v-if="menuInx == 1">
                       <Personal />
                    </div>
                    <div class="yi" v-if="menuInx == 2">
                        <Authentication />
                    </div>
                    <div class="yi" v-if="menuInx == 3">
                        <AccountSettings />
                    </div>
                    <div class="yi" v-if="menuInx == 4">
                        <Password />
                    </div>
                    <div class="yi" v-if="menuInx == 5">
                        <Wallet />
                    </div>
                    <div class="yi" v-if="menuInx == 6">
                        <Shipping />
                    </div>
                    <div class="yi" v-if="menuInx == 7">
                        <Agreement />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import TopNavigation from "../HP/TopNavigationB.vue";
import Personal from './PersonalPage.vue';
import Authentication from './AuthenticationPage.vue'
import AccountSettings from "./AccountSettingsPage.vue";
import Password from "./PasswordPage.vue";
import Wallet from "./WalletPage.vue";
import Shipping from "./ShippingPage.vue";
import Agreement from "./AgreementPage.vue";

export default {
    components:{
        TopNavigation,
        // 个人资料
        Personal,
        // 用户认证
        Authentication,
        // 账号设置
        AccountSettings,
        // 密码设置
        Password,
        // 平台协议
        Agreement,
        // 我的钱包
        Wallet,
        // 船司账号
        Shipping,
    },
    data() {
        return {
            menuInx: '1',
        }
    },
    methods: {
        handleSelect(key) {
            this.menuInx = key
        }
    },
    mounted(){
        if(this.$route.params.menuInx != undefined){
            this.menuInx = this.$route.params.menuInx
        }
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.wode{
    background: #F9F9F9;
    width: 100%;
    height: 100%;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}

.conetenr{
    margin-bottom: 20px;

    display: flex;
    justify-content: space-between;

    .el-menu{
        width: 200px;
        height: 304px;
        background: #FFFFFF;
        border-radius: 12px 12px 12px 12px;

        border: 0;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
        font-style: normal;
        text-transform: none;

        overflow: hidden;

        padding: 32px 0;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        box-sizing: border-box;
        li{
            // height: 32px;
            display: flex;
            align-items: center;
            border-left: solid 3px #fff;
        }

        li:hover{
            color: #0073F5;
            background: #fff;
        }

        .el-menu-item{
            height: 24px;
        }
    }
    .is-active{
        
        color: #0073F5;
        background: #fff;
        border-left: solid 3px #0073F5 !important;
    }
    .menu-con{
        width: 976px;
        background: #fff;
        border-radius: 12px 12px 12px 12px;
    }
}
</style>